define('view/people/internal.associations.list.view',['require','exports','module','underscore','uikit/uikit','blockit','fukit/fukit','backbone.radio','fukit/fukit','fukit/fukit','behavior/show.detail.on.table.row.double.press.behavior','fukit/fukit'],function(require, exports, module) {
  //prettier-ignore
  var _           = require('underscore'),
      UIKit       = require('uikit/uikit'),
      BlocKit     = require('blockit'),
      RouteHelper = require('fukit/fukit').RouteHelper,
      Radio       = require('backbone.radio'),
      ROLES       = require('fukit/fukit').Roles,

  //Behaviors
      NavigateOnEventBehavior                 = require('fukit/fukit').NavigateOnEventBehavior,
      ShowDetailOnTableRowDoublePressBehavior = require('behavior/show.detail.on.table.row.double.press.behavior'),
      AuthorizationBehavior                   = require('fukit/fukit').AuthorizationBehavior;

  // var ANY_UNIT_ROLE = [ROLES.UNIT_CREATE, ROLES.UNIT_READ, ROLES.UNIT_UPDATE, ROLES.UNIT_DELETE];

  var getPrimaryId = function() {
    var personModel = Radio.request('AppKit.resourceService', 'resource', 'person');

    return personModel.id;
  };

  var InternalAssociationsView = UIKit.ItemView.extend({
    template: 'associations.list.view',

    internalViewOptions: {
      headerTextView: function() {
        return {
          text: 'Internal Associations',
        };
      },
      tableView: function() {
        var ASSOCIATION_COLUMNS = [
          {
            childView: BlocKit.EllipsisColumnView,
            childViewOptions: {
              resolveOptions: {
                components: [
                  {
                    text: 'View',
                    icon: 'pencil',
                    behaviors: {
                      NavigateOnEventBehavior: {
                        behaviorClass: NavigateOnEventBehavior,
                        model: '@this.model',
                        routeParams: { id: '@model.id', primaryId: getPrimaryId() },
                        routeName: 'internalassociations:detail',
                      },
                      // AuthorizationBehavior: {
                      //   setTextWhen: [
                      //     {
                      //       filter: function() {
                      //         return true
                      //       },
                      //       text: 'View',
                      //       roles: [
                      //         [ROLES.PERSON_INTERNAL_AFFILIATION_UPDATE],
                      //         ANY_UNIT_ROLE
                      //       ]
                      //     }
                      //   ],
                      //   behaviorClass: AuthorizationBehavior
                      // }
                    },
                  },
                ],
              },
            },
            collapsing: true,
          },
          { text: 'Unit', data: 'relationships.unit.name' },
          { text: 'Title', data: 'title' },
        ];

        return {
          columns: ASSOCIATION_COLUMNS,
          collection: this.collection,
          selectable: true,
          basic: true,
          borderless: true,
          tabletStackable: true,
          behaviors: {
            rowDoublePressBehavior: {
              behaviorClass: ShowDetailOnTableRowDoublePressBehavior,
              doublePressOptions: {
                routeName: 'internalassociations:detail',
                params: [
                  { paramName: 'id', paramAttribute: 'id' },
                  { paramName: 'primaryId', paramValue: getPrimaryId() },
                ],
              },
            },
          },
        };
      },
    },

    onTableViewRowAction: function(table, row, action) {
      var actionName = action.get('action');
      if (actionName) {
        this.trigger('item:' + actionName, row.model);
      }
    },
  });

  module.exports = InternalAssociationsView;
});

